<main>
    <h1>Häufig gestellte Fragen</h1>
    <p>
        Finden Sie schnell Antworten zu elektronischen Signaturen mit {{ '{{domain}}' | changeDomain }}
    </p>
    <p-accordion [multiple]="true">
        <p-accordionTab *ngFor="let cat of faqs; let i = index" [header]="cat.title | changeDomain" [selected]="i === 0">
            <p-accordion [multiple]="true" class="no-shadow">
                <p-accordionTab *ngFor="let item of cat.items" [header]="item.question | changeDomain">
                    <ul>
                        <li *ngFor="let a of item.answer">{{ a | changeDomain }}</li>
                    </ul>
                </p-accordionTab>
            </p-accordion>
        </p-accordionTab>
    </p-accordion>
    <p>&nbsp;</p>
</main>
